export default __webpack_public_path__ + "static/Lisboa2020_RGB_1c-eb57439707a303799d276087483a4f57.png";